import React from 'react';
import { Typography } from '@mui/material';


interface ShowLabelProps {
  show: boolean | "" | undefined,
  message: string,
}

const ErrorLabel: React.FC<ShowLabelProps> = ({show, message}) => {

  return (
    <div>
      {show &&
        <Typography align="center" variant="subtitle2">
          {message}
        </Typography>
      }
    </div>
  )
}

const SuccessLabel: React.FC<ShowLabelProps> = ({show, message}) => {
  return (
    <div>
      {show &&
        <Typography align="center" variant="subtitle2" >
          {message}
        </Typography>
      }
    </div>
  )
}

export { SuccessLabel, ErrorLabel }